export const findChildIndex = (parentNode, targetNode) => {
    let targetIndex = -1;
    parentNode.forEach((node, _, index) => {
        if (node === targetNode) {
            targetIndex = index;
        }
    });
    return targetIndex;
};
